import type { PortalTaskGroupKey } from '../model/myTasks';

const MY_TASKS_ROOT = '/portal/todos';
const TASK_GROUPS = new Set<PortalTaskGroupKey>(['todo', 'done', 'cc', 'initiated']);

export type MyTasksRoute = {
  group: PortalTaskGroupKey;
  taskId?: string;
};

export function parseMyTasksRoute(pathname: string): MyTasksRoute {
  const suffix = pathname.startsWith(`${MY_TASKS_ROOT}/`)
    ? pathname.slice(`${MY_TASKS_ROOT}/`.length)
    : '';
  if (!suffix) return { group: 'todo' };

  const [candidateGroup, ...taskIdParts] = suffix.split('/');
  if (TASK_GROUPS.has(candidateGroup as PortalTaskGroupKey)) {
    return {
      group: candidateGroup as PortalTaskGroupKey,
      taskId: taskIdParts.length ? taskIdParts.join('/') : undefined,
    };
  }

  // 兼容历史深链 /portal/todos/{taskId}，历史链接默认属于待办。
  return { group: 'todo', taskId: suffix };
}

export function buildMyTasksRoute(group: PortalTaskGroupKey, taskId?: string) {
  return `${MY_TASKS_ROOT}/${group}${taskId ? `/${taskId}` : ''}`;
}
